import React from "react";
import "../App.css";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { FaSchool, FaBuilding, FaUserGraduate } from "react-icons/fa";
import { FcHome } from "react-icons/fc";

const Education = () => {
  return (
    <div id="education" className="about-wraper">
      <h1 className="about-header">Education</h1>
      <VerticalTimeline>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: "rgb(84, 7, 113)", color: "#fff" }}
          contentArrowStyle={{ borderRight: "7px solid  rgb(84, 7, 113)" }}
          date="2016 - 2020"
          iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
          icon={<FaUserGraduate />}
        >
          <h3 className="vertical-timeline-element-title">
            B.Tech (Computer Sci. & Technology)
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            Department Of Technology
          </h4>
          <p>Shivaji University, kolhapur, MH</p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: "rgb(84, 7, 113)", color: "#fff" }}
          contentArrowStyle={{ borderRight: "7px solid  rgb(84, 7, 113)" }}
          date="2016"
          iconStyle={{ background: "rgb(223, 42, 27)", color: "#fff" }}
          icon={<FaBuilding />}
        >
          <h3 className="vertical-timeline-element-title">HSC</h3>
          <h4 className="vertical-timeline-element-subtitle">Birla College </h4>
          <p>Kalyan, MH</p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: "rgb(84, 7, 113)", color: "#fff" }}
          contentArrowStyle={{ borderRight: "7px solid  rgb(84, 7, 113)" }}
          date="2014"
          iconStyle={{ background: "rgb(235, 238, 102)", color: "#081675" }}
          icon={<FaSchool />}
        >
          <h3 className="vertical-timeline-element-title">SSC</h3>
          <h4 className="vertical-timeline-element-subtitle">
            Guru Nanak English High School{" "}
          </h4>
          <p>Kalyan, MH</p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          iconStyle={{ background: "rgb(16, 204, 82)", color: "#fff" }}
          icon={<FcHome />}
        />
      </VerticalTimeline>
    </div>
  );
};
export default Education;
